import {
  ChangeDetectionStrategy,
  Component,
  effect,
  input,
  output,
  signal,
} from '@angular/core';
import { AysVirtualClinic } from '@bindoc-projects/virtual-clinic-domain-lib';
import { BdUiSingleSelectComponent, BdUiSingleSelectConfig } from '@bindoc-projects/ui-lib/selection/ui';
import { Observable, of } from 'rxjs';

@Component({
  selector: 'ays-virtual-clinic-structural-select-year',
  template: `
    <bd-ui-single-select
      [config]="config"
      [initialSelection]="initial()"
      [selectOptions]="yearOptions()"
      (selection)="onYearSelect($event)"
    ></bd-ui-single-select>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [BdUiSingleSelectComponent],
})
export class AysVirtualClinicStructuralSelectYearComponent {
  readonly virtualClinic = input.required<AysVirtualClinic>();

  readonly yearSelect = output<number>();

  public readonly config: BdUiSingleSelectConfig<number> = {
    id: 'virtual-clinic-structural-select-year',
    selectLabel: 'Jahr',
    option: {
      sortFnc: (a, b) => a - b,
      uniqueFnc: (option) => option.toString(),
      searchOptionAccessor: (option) => option.toString(),
    },
  };

  readonly yearOptions = signal<Observable<number[]>>(of([]));
  readonly initial = signal<number | null>(null);

  constructor() {
    effect(() => {
      const vc = this.virtualClinic();
      if (vc.clinicInformation?.dismissalDateRange) {
        const options = vc.clinicInformation.dismissalDateRange.getYears();
        this.yearOptions.set(of(options));
        this.onYearSelect(options[options.length - 1]);
      } else {
        this.initial.set(null);
        this.yearOptions.set(of([]));
      }
    });
  }

  public onYearSelect(year: number) {
    this.initial.set(year);
    this.yearSelect.emit(year);
  }
}
